// import JSZip from "jszip";
// import { saveAs } from "file-saver";
import React, { useEffect, useState } from "react";
import { Table, Tooltip, Popconfirm, Checkbox, message, Button, Card, Row, Col, Typography } from "antd";
import { EditOutlined,FileAddOutlined , DeleteOutlined, ReloadOutlined,DownloadOutlined  } from "@ant-design/icons";

// import { DeleteOutlined, ReloadOutlined } from "@ant-design/icons";
import { BASE_URL } from "../Components/Constant";

const { Title } = Typography;

const PluginsList = () => {
  const [plugins, setPlugins] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchPlugins();
  }, []);

  const fetchPlugins = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${BASE_URL}/plugins/retrieve`);
      const data = await res.json();
      setPlugins(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Error fetching plugins:", err);
      message.error("Failed to load plugins");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (pluginName) => {
    try {
      const res = await fetch(`${BASE_URL}/plugins/${pluginName}`, {
        method: "DELETE",
      });

      if (!res.ok) throw new Error("Failed to delete plugin");

      message.success("Plugin deleted successfully");
      fetchPlugins();
    } catch (error) {
      console.error("Delete error:", error);
      message.error("Could not delete plugin");
    }
  };

  const handleDownloadZip = async (pluginName) => {
  try {
    const res = await fetch(`${BASE_URL}/plugins/download_zip?name=${pluginName}`);

    if (!res.ok) {
      message.error("Failed to download ZIP");
      return;
    }

    // Convert response to blob
    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);

    // Create a temporary link to trigger download
    const a = document.createElement("a");
    a.href = url;
    a.download = `${pluginName}.zip`;
    document.body.appendChild(a);
    a.click();
    a.remove();

    window.URL.revokeObjectURL(url);
  } catch (err) {
    console.error("Download error:", err);
    message.error("ZIP download failed");
  }
};

// const downloadTemplate = async () => {
//   const zip = new JSZip();
// const folderPath = "/Plugin_Arch/plugin_template";
//   console.log(folderPath)
//   await fetchFolderFiles(folderPath, zip);
//   console.log("Fetched folder files");

//   const blob = await zip.generateAsync({ type: "blob" });
//   console.log("Generated ZIP blob");
//   saveAs(blob, "template.zip");
// };

async function fetchFolderFiles(path, zip) {
  const res = await fetch(path);
  const text = await res.text();

  const parser = new DOMParser();
  const doc = parser.parseFromString(text, "text/html");

  const links = [...doc.querySelectorAll("a")];

  for (let link of links) {
    const name = link.getAttribute("href");

    if (name === "../") continue; // skip parent folder

    const fullPath = path + "/" + name;

    if (name.endsWith("/")) {
      // It's a folder → create subfolder in zip
      const folder = zip.folder(name.replace("/", ""));
      await fetchFolderFiles(fullPath.slice(0, -1), folder);
    } else {
      // It's a file → fetch and add to zip
      const fileRes = await fetch(fullPath);
      const blob = await fileRes.blob();
      zip.file(name, blob);
    }
  }
}
const handleCreateNew = () => {
  try {
    const link = document.createElement("a");
    link.href = "/DummyPlugin.zip"; // from public folder
    link.download = "DummyPlugin.zip";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (err) {
    console.error("Template download failed:", err);
    message.error("Failed to download template");
  }
};

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      width: 180,
    },
    {
      title: "Version",
      dataIndex: "version",
      width: 150,
    },
    {
      title: "Description",
      dataIndex: "description",
      width: 250,
      ellipsis: true,
    },
    {
      title: "Global Render",
      dataIndex: "globalRenderName",
      width: 200,
      ellipsis: true,
    },
    {
      title: "Unmount Name",
      dataIndex: "unmountName",
      width: 200,
      ellipsis: true,
    },
    
          {
      title: "Actions",
      key: "actions",
      width: 110,
      render: (_, record) => (
        <>
         <Tooltip title="Download Source ZIP">
        <DownloadOutlined
          onClick={() => handleDownloadZip(record.name)}
          style={{ marginRight: 12, cursor: "pointer", color: "#1677ff" }}
        />
      </Tooltip>
          <Tooltip title="Edit Plugin">
            <EditOutlined
              onClick={() => message.info("Edit Form not implemented yet")}
              style={{ marginRight: 12, cursor: "pointer" }}
            />
          </Tooltip>

          <Tooltip title="Delete Plugin">
            <Popconfirm
              title="Delete this plugin file?"
              okText="Yes"
              cancelText="No"
              onConfirm={() => handleDelete(record.name)}
            >
              <DeleteOutlined style={{ color: "red", cursor: "pointer" }} />
            </Popconfirm>
          </Tooltip>
        </>
      ),
    },
  ];

  return (
    <Card>
      <Row justify="space-between" align="middle" style={{ marginBottom: 20 }}>
        <Col>
          <Title level={4}>Plugins</Title>
        </Col>
        <Col>
        <Button icon={<FileAddOutlined  />} onClick={handleCreateNew}  type="primary"  style={{ marginRight: 10  }}>
            Create New
          </Button>
        {/* </Col> */}

        {/* <Col> */}
          <Button icon={<ReloadOutlined />} onClick={fetchPlugins}>
            Refresh
          </Button>
        </Col>
      </Row>

      <Table
        columns={columns}
        dataSource={plugins}
        rowKey="name"
        loading={loading}
        scroll={{ x: 1100 }}
        pagination={{
          pageSize: 10,
          showSizeChanger: true,
        }}
      />
    </Card>
  );
};

export default PluginsList;